import {set_server_result} from "../engine/madnes/madnes_variables";
import {madnes_adapter} from "../engine/madnes/madnes_variables";

import events from "../events/EventsObservable";
import {GAME_EVENTS} from "./gameEvents";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig from "../system/SystemConfig";
import IGameCore from "./IGameCore";

@injectable()
class GameMadnesCore implements IGameCore {

    private config: SystemConfig;
    private gameset: any;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig
    ) {

        this.config = config;
        this.gameset = config.gameset;

    }

    create() {

    }

    async start() {
        set_server_result(null);
        madnes_adapter.game_start();
    }

    stop(addResult, resultIndex = 0) {

        let symbolsMatrix = addResult.getReelMatrix()[0];

        set_server_result(addResult.getData());

        events.dispatch(GAME_EVENTS.GAME_ADD_RESULT, { addResult, symbolsMatrix });
    }

    /**
     * @param {AddResult} addResult
     */
    stopFreespins(addResult) {
        let symbolsMatrix = addResult.getReelMatrix()[0];
        // set_server_result(addResult.getData()); -- DO NOT UNCOMMENT THIS!!! - every old "madnes" game solves this individually in `control_freespins` function
        events.dispatch(GAME_EVENTS.GAME_ADD_RESULT, { addResult, symbolsMatrix })
    }

    stopFail(failResult) {
        set_server_result(failResult.getData());
        events.dispatch(GAME_EVENTS.GAME_ADD_FAIL_RESULT, failResult);
    }

    forcestop() {}

}

export default GameMadnesCore